import { APP_INITIALIZER, Provider } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "./modules/fraud/partials/services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { catchError, from, map, Observable, tap } from "rxjs";
import { AccountDto } from "./modules/fraud/api/models/fraud.models";
import { parseUrlBotFromStartParam } from "./modules/fraud/partials/helpers/parse-url-start-param";
import { parseQueryParams } from "./modules/fraud/partials/helpers/parse-query-params";
import { HttpErrorResponse } from "@angular/common/http";
import { ErrorNavigationService } from "./modules/fraud/partials/services/error-navigation.service";

export const appConfigInit: Provider = {
  provide: APP_INITIALIZER,
  useFactory: (
    router: Router,
    authService: AuthService,
    errorNavigationService: ErrorNavigationService,
    translateService: TranslateService,
  ) => {
    return (): Observable<boolean | AccountDto> | Promise<boolean> => {
      let url: URL = new URL(window.location.href);

      const stringUrl: string = String(url);
      const hasStartParam = stringUrl.includes('start_param');
      const test = 'query_id=AAGr68YUAwAAAKvrxhSU33RL&user=%7B%22id%22%3A6791031723%2C%22first_name%22%3A%22Oskar%20%F0%9F%92%A0%22%2C%22last_name%22%3A%22QA%22%2C%22username%22%3A%22osckar_qa%22%2C%22language_code%22%3A%22ru%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ftelegram.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FuDf7YB8oS2yew9uOUnbEiZZzy6Wo4NSYCfUEX26RWMUJT3nyIK_1tnoxItjbhuAf.svg%22%7D&auth_date=1753355087&signature=l9P0jH4ztdjkga3uxU-VwX0Ijl8XIrDLedw2nNCHhyjRC1eL0_d5VFYX9ZQo6-7ostB4YhovClVEv2otZSygDQ&hash=a67a46ed29818a01632b48f021c9ea795696d6ad0a7ac805491386ddf7d4258b'

      console.log('url', url);
      console.log('stringUrl', stringUrl);
      // https://stage-tg-app.starexchange.dev/?tgWebAppStartParam=path%3Daml_scan__uuid%3Duuid#tgWebAppData=user%3D%257B%2522id%2522%253A393283805%252C%2522first_name%2522%253A%2522%25D0%2590%25D0%25BB%25D0%25B5%25D0%25BA%25D1%2581%25D0%25B0%25D0%25BD%25D0%25B4%25D1%2580%2522%252C%2522last_name%2522%253A%2522%25D0%259F%25D1%258B%25D0%25BB%25D1%258B%25D0%25BF%25D0%25B5%25D0%25BD%25D0%25BA%25D0%25BE%2522%252C%2522username%2522%253A%2522AleksandrPylypenko%2522%252C%2522language_code%2522%253A%2522ru%2522%252C%2522photo_url%2522%253A%2522https%253A%255C%252F%255C%252Ft.me%255C%252Fi%255C%252Fuserpic%255C%252F320%255C%252F3i8YbJCc5NhUGAxEBf0OfcRJJkF03DJfNP4WCzCK-ZM.svg%2522%257D%26chat_instance%3D461592744954170651%26chat_type%3Dgroup%26start_param%3Dpath%253Daml_scan__uuid%253Duuid%26auth_date%3D1762527904%26signature%3DzoK2UvuLEZCtU2-n16_3W6Y3thB6ToFKQ8NTeYt5txPJk4ped8UPTNv5iVmq0wGwuXme3nS5Bkrl0EMVVExLCQ%26hash%3Deae0498fdd707b11bfe4d089b531d4b2482c365b6154b3210f02cd55a57644fe&tgWebAppVersion=9.1&tgWebAppPlatform=weba&tgWebAppThemeParams=%7B%22bg_color%22%3A%22%23212121%22%2C%22text_color%22%3A%22%23ffffff%22%2C%22hint_color%22%3A%22%23aaaaaa%22%2C%22link_color%22%3A%22%238774e1%22%2C%22button_color%22%3A%22%238774e1%22%2C%22button_text_color%22%3A%22%23ffffff%22%2C%22secondary_bg_color%22%3A%22%230f0f0f%22%2C%22header_bg_color%22%3A%22%23212121%22%2C%22accent_text_color%22%3A%22%238774e1%22%2C%22section_bg_color%22%3A%22%23212121%22%2C%22section_header_text_color%22%3A%22%23aaaaaa%22%2C%22subtitle_text_color%22%3A%22%23aaaaaa%22%2C%22destructive_text_color%22%3A%22%23e53935%22%7D
      // https://stage-tg-app.starexchange.dev/?tgWebAppStartParam=path%3Daml_scan__uuid%3DAMLSCAN-3b9f16b6-8d23-4388-92c5-fca7d7cc79f0#tgWebAppData=user%3D%257B%2522id%2522%253A393283805%252C%2522first_name%2522%253A%2522%25D0%2590%25D0%25BB%25D0%25B5%25D0%25BA%25D1%2581%25D0%25B0%25D0%25BD%25D0%25B4%25D1%2580%2522%252C%2522last_name%2522%253A%2522%25D0%259F%25D1%258B%25D0%25BB%25D1%258B%25D0%25BF%25D0%25B5%25D0%25BD%25D0%25BA%25D0%25BE%2522%252C%2522username%2522%253A%2522AleksandrPylypenko%2522%252C%2522language_code%2522%253A%2522ru%2522%252C%2522photo_url%2522%253A%2522https%253A%255C%252F%255C%252Ft.me%255C%252Fi%255C%252Fuserpic%255C%252F320%255C%252F3i8YbJCc5NhUGAxEBf0OfcRJJkF03DJfNP4WCzCK-ZM.svg%2522%257D%26chat_instance%3D461592744954170651%26chat_type%3Dgroup%26start_param%3Dpath%253Daml_scan__uuid%253DAMLSCAN-3b9f16b6-8d23-4388-92c5-fca7d7cc79f0%26auth_date%3D1762528088%26signature%3DhcOk0pqLmyEouv3UJneAlc3r1Q02K2P-1kd1-rCB6wuOsrPO6mDEMaOey7iMdDjtLaSji9elRIQy-u2by_UkAg%26hash%3D16f2c4daccce32cca1a5ea20b411d22ce85ed60d1c0913761764de3c674c1c34&tgWebAppVersion=9.1&tgWebAppPlatform=weba&tgWebAppThemeParams=%7B%22bg_color%22%3A%22%23212121%22%2C%22text_color%22%3A%22%23ffffff%22%2C%22hint_color%22%3A%22%23aaaaaa%22%2C%22link_color%22%3A%22%238774e1%22%2C%22button_color%22%3A%22%238774e1%22%2C%22button_text_color%22%3A%22%23ffffff%22%2C%22secondary_bg_color%22%3A%22%230f0f0f%22%2C%22header_bg_color%22%3A%22%23212121%22%2C%22accent_text_color%22%3A%22%238774e1%22%2C%22section_bg_color%22%3A%22%23212121%22%2C%22section_header_text_color%22%3A%22%23aaaaaa%22%2C%22subtitle_text_color%22%3A%22%23aaaaaa%22%2C%22destructive_text_color%22%3A%22%23e53935%22%7D

      const getTelegramInitData = window?.Telegram?.WebApp?.initData;
      // Функция для проверки валидности initData
      const isValidInitData = (initData: string): boolean => {
        if (!initData) return false;
        const parsedInitData = parseQueryParams(initData);
        // Проверяем наличие важных параметров (user, auth_date, hash/signature)
        // query_id один не является достаточным для аутентификации
        const hasUser = !!parsedInitData['user'];
        const hasAuthDate = !!parsedInitData['auth_date'];
        const hasHash = !!parsedInitData['hash'] || !!parsedInitData['signature'];
        const hasOnlyQueryId = Object.keys(parsedInitData).length === 1 && !!parsedInitData['query_id'];
        
        return !hasOnlyQueryId && (hasUser || (hasAuthDate && hasHash));
      };

      if (getTelegramInitData && isValidInitData(getTelegramInitData)) {
        localStorage.setItem('authTelegramData', getTelegramInitData);
      }

      const telegramInitDataLocalStorage: string | null = localStorage.getItem('authTelegramData');

      translateService.use('en');
      const telegramData = getTelegramInitData || telegramInitDataLocalStorage;
      
      // Парсинг параметров из initData
      let chatType: string | undefined;
      if (telegramData) {
        const parsedInitData = parseQueryParams(telegramData);
        chatType = parsedInitData['chat_type'];
      }

      if (chatType === 'group' || chatType === 'supergroup') {
        localStorage.setItem('isGroupChat', 'true');
      } else {
        localStorage.getItem('isGroupChat') && localStorage.removeItem('isGroupChat');
      }

      if (!telegramData) {
        return router.navigate(['401']);
      }

      return authService.getUser().pipe(
        tap(async (user: AccountDto | undefined) => {
          if (!user) {
            return;
          }
          // projectSettingsService.load();
          const supportLocales = ['en', 'ru'];
          const { locale } = user.user;
          translateService.addLangs(supportLocales);
          // TODO: Return after add ru locale
          // translateService.use(supportLocales.includes(locale) ? locale : 'en');
          translateService.use('en');
          if (hasStartParam) {
            const queryParamsWithCustom = parseUrlBotFromStartParam(stringUrl);
            if (queryParamsWithCustom['path'] === 'aml_scan') {
              // router.navigate([`/add-information/${queryParamsWithCustom['uuid']}`]);
              router.navigate([`/transaction-report`], {queryParams: {id: queryParamsWithCustom['uuid']}});
              return;
            }
            const { path, ...queryParams } = queryParamsWithCustom;
            router.navigate([`/${path}`], { queryParams });
          }
          if (!user) {
            return;
          }
          if (!user.user.isWelcomePageViewed) {
            router.navigate(['welcome']);
            return;
          }
      
          if (user?.userPlan.userPlanType === 'BASIC') {
            let lastUserPlan = false;
            switch (user?.accountType) {
              case 'PERSONAL':
                if (user?.lastExpiredUserPlan) {
                  lastUserPlan = user?.paidFeatureLocked;
                }
                break;
              case 'CORPORATE':
                if (user?.companyDto?.lastExpiredUserPlan) {
                  lastUserPlan = user?.companyDto?.paidFeatureLocked;
                }
                break;
            }
            if (lastUserPlan) {
              // TODO Replace output logic
              setTimeout(() => {
                authService.openSubscriptionExpiredDialog();
              }, 150);
            }
          }
        }),
        map(Boolean),
        catchError((error: HttpErrorResponse) => {
          console.log('error', error);
          return from(errorNavigationService.handleHttpError(error).then(() => false));
        }));
    }
  },
  deps: [
    Router,
    AuthService,
    ErrorNavigationService,
    TranslateService,
  ],
  multi: true
};
